import { render, staticRenderFns } from "./CardStatus.vue?vue&type=template&id=1a1712cd&scoped=true&"
import script from "./CardStatus.vue?vue&type=script&lang=js&"
export * from "./CardStatus.vue?vue&type=script&lang=js&"
import style0 from "./card_status.scss?vue&type=style&index=0&id=1a1712cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1712cd",
  null
  
)

export default component.exports